import { render, staticRenderFns } from "./LogTableGBS.vue?vue&type=template&id=4862cdae&scoped=true&"
import script from "./LogTableGBS.vue?vue&type=script&lang=js&"
export * from "./LogTableGBS.vue?vue&type=script&lang=js&"
import style0 from "./LogTableGBS.vue?vue&type=style&index=0&id=4862cdae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4862cdae",
  null
  
)

export default component.exports